/** Teks panel allowlist email demo di /admin/users (id/en). `{date}` = tanggal pakai. */

export interface AllowedEmailText {
	title: string;
	description: string;
	emailLabel: string;
	emailPlaceholder: string;
	noteLabel: string;
	notePlaceholder: string;
	add: string;
	columns: {
		email: string;
		note: string;
		status: string;
		access: string;
		actions: string;
	};
	unused: string;
	usedAt: string;
	remove: string;
	removeConfirmTitle: string;
	removeConfirmBody: string;
	cancel: string;
	empty: string;
	loadFailed: string;
	addedOk: string;
	removedOk: string;
	failed: string;
	confirm: string;
	roleLabel: string;
	roles: { admin: string; user: string };
	selfRoleHint: string;
	roleConfirmTitle: string;
	roleConfirmBody: string;
	roleUpdatedOk: string;
	verified: string;
	unverified: string;
	verifyAction: string;
	unverifyAction: string;
	verifyConfirmTitle: string;
	verifyConfirmBody: string;
	unverifyConfirmTitle: string;
	unverifyConfirmBody: string;
	verifiedOk: string;
	unverifiedOk: string;
	noAccount: string;
}

export const allowedEmailTexts: Record<"id" | "en", AllowedEmailText> = {
	id: {
		title: "Allowlist Email Demo",
		description:
			"Email yang terdaftar langsung aktif saat login dengan Google (tanpa Acc manual). Email lain yang login dengan Google tetap menunggu Acc admin.",
		emailLabel: "Email",
		emailPlaceholder: "nama@contoh.com",
		noteLabel: "Catatan",
		notePlaceholder: "Mis. Demo Dinas X",
		add: "Tambah",
		columns: {
			email: "Email",
			note: "Catatan",
			status: "Status",
			access: "Akses",
			actions: "Aksi",
		},
		unused: "Belum dipakai",
		usedAt: "Dipakai pada {date}",
		remove: "Hapus entri",
		removeConfirmTitle: "Hapus entri allowlist?",
		removeConfirmBody:
			"Menghapus entri tidak mencabut akses user yang sudah terverifikasi.",
		cancel: "Batal",
		empty: "Belum ada email di allowlist",
		loadFailed: "Gagal memuat allowlist",
		addedOk: "Email ditambahkan",
		removedOk: "Entri dihapus",
		failed: "Terjadi kesalahan",
		confirm: "Ya, lanjutkan",
		roleLabel: "Role",
		roles: { admin: "Admin", user: "Pengguna" },
		selfRoleHint: "Tidak bisa mengubah role akun sendiri",
		roleConfirmTitle: "Ubah role user?",
		roleConfirmBody: "Role user ini akan diubah menjadi {role}.",
		roleUpdatedOk: "Role diperbarui",
		verified: "Terverifikasi",
		unverified: "Belum diverifikasi",
		verifyAction: "Verifikasi user",
		unverifyAction: "Cabut verifikasi",
		verifyConfirmTitle: "Verifikasi user?",
		verifyConfirmBody: "User ini akan bisa mengakses dashboard.",
		unverifyConfirmTitle: "Cabut verifikasi?",
		unverifyConfirmBody: "User ini tidak bisa lagi mengakses dashboard.",
		verifiedOk: "User diverifikasi",
		unverifiedOk: "Verifikasi dicabut",
		noAccount: "Belum ada akun",
	},
	en: {
		title: "Demo Email Allowlist",
		description:
			"Listed emails are activated immediately when signing in with Google (no manual approval). Other emails signing in with Google still wait for admin approval.",
		emailLabel: "Email",
		emailPlaceholder: "name@example.com",
		noteLabel: "Note",
		notePlaceholder: "E.g. Demo Office X",
		add: "Add",
		columns: {
			email: "Email",
			note: "Note",
			status: "Status",
			access: "Access",
			actions: "Actions",
		},
		unused: "Not used yet",
		usedAt: "Used on {date}",
		remove: "Remove entry",
		removeConfirmTitle: "Remove allowlist entry?",
		removeConfirmBody:
			"Removing an entry does not revoke access for users already verified.",
		cancel: "Cancel",
		empty: "No emails in the allowlist yet",
		loadFailed: "Failed to load allowlist",
		addedOk: "Email added",
		removedOk: "Entry removed",
		failed: "Something went wrong",
		confirm: "Yes, continue",
		roleLabel: "Role",
		roles: { admin: "Admin", user: "User" },
		selfRoleHint: "You cannot change your own role",
		roleConfirmTitle: "Change user role?",
		roleConfirmBody: "This user's role will be changed to {role}.",
		roleUpdatedOk: "Role updated",
		verified: "Verified",
		unverified: "Not verified",
		verifyAction: "Verify user",
		unverifyAction: "Revoke verification",
		verifyConfirmTitle: "Verify user?",
		verifyConfirmBody: "This user will be able to access the dashboard.",
		unverifyConfirmTitle: "Revoke verification?",
		unverifyConfirmBody:
			"This user will no longer be able to access the dashboard.",
		verifiedOk: "User verified",
		unverifiedOk: "Verification revoked",
		noAccount: "No account yet",
	},
};
